import { Component, OnInit, Input } from '@angular/core'
import { environment } from '../../../environments/environment'
import { ContextService } from '../../services/context.service'
import { Delivery } from '../../models/Vertical'

@Component({
  standalone: false,
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit {
  @Input() showContext = false
  @Input() onlyData = false
  @Input() compareMode = false
  @Input() selectedCompareDelivery: Delivery
  @Input() datasetName = null

  @Input()
  get stats() {
    return this._stats
  }

  set stats(value: any[]) {
    this._stats = value
    if (Array.isArray(value)) {
      const refVal = value[0]
      const compVal = value[1]
      this.percentDiff = ((refVal - compVal) / compVal) * 100
    }
  }

  get referenceStats() {
    return this.compareMode && this.stats ? this.stats[0] || [] : this.stats
  }

  get comparisonStats() {
    return this.compareMode && this.stats ? this.stats[1] || [] : null
  }

  get keyIndicator() {
    return this.contextService.keyIndicator.label.toLowerCase()
  }

  _stats = []
  percentDiff = 0

  constructor(private contextService: ContextService) {}

  ngOnInit() {
    if (!this.datasetName) {
      this.datasetName = this.contextService.getContext().delivery.name
    }
  }

  hasReferenceStats() {
    return this.referenceStats || this.referenceStats === 0
  }

  getTitle() {
    return this.isDensityActive()
      ? 'Density'
      : !this.isOOH()
      ? 'Number of ' + this.keyIndicator
      : this.keyIndicator
  }

  isDensityActive() {
    return this.contextService.isDensityActive()
  }

  isOOH() {
    return this.contextService.vertical.isOOH()
  }
}
